<template>
  <div id='bd-main'>
    <!-- {{ userCurrentChatType }} -->
    <el-empty v-if="userCurrentChatType == 'thread'" description="空"></el-empty>
    <div v-if="isContact">
      <p><img class="avatar" width="100" height="100" :alt="userCurrentContact.nickname" :src="userCurrentContact.avatar"></p>
      <p>{{ userCurrentContact.nickname }}</p>
      <p>{{ userCurrentContact.description }}</p>
      <el-button type="success" @click="startContactChat" style="margin-top: 10px;">{{ $t('sendMessage') }}</el-button>
    </div>
    <div v-if="isGroup">
      <p><img class="avatar" width="100" height="100" :alt="userCurrentGroup.nickname" :src="userCurrentGroup.avatar"></p>
      <p>{{ userCurrentGroup.nickname }}</p>
      <p>{{ userCurrentGroup.description }}</p>
      <el-button type="success" @click="startGroupChat" style="margin-top: 10px;">{{ $t('sendMessage') }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
const constants = require('@/util/constants')

export default {
  name: 'bd-main',
  data () {
    return {
      //
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentChatType', 'userCurrentContact', 'userCurrentGroup' ]),
    isContact () {
      return this.userCurrentChatType === constants.THREAD_TYPE_CONTACT
    },
    isGroup () {
      return this.userCurrentChatType === constants.THREAD_TYPE_GROUP
    }
  },
  methods: {
    ...mapActions([ 'getContactThread', 'getGroupThread' ]),
    startContactChat () {
      let cid = this.userCurrentContact.uid
      // console.log('startContactChat:', cid)
      this.getContactThread(cid)
      this.$router.replace('/admin/chat')
    },
    startGroupChat () {
      let gid = this.userCurrentGroup.gid
      // console.log('startGroupChat:', gid)
      this.getGroupThread(gid)
      this.$router.replace('/admin/chat')
    }
  }
}
</script>

<style scoped>
#bd-main {
  padding-left: 10px;
  padding-top: 50px;
  height: 100%;
  width: 100%;
}
</style>
